import { render, staticRenderFns } from "./AddPPMyearly.vue?vue&type=template&id=40cffb6e&scoped=true"
import script from "./AddPPMyearly.vue?vue&type=script&lang=ts"
export * from "./AddPPMyearly.vue?vue&type=script&lang=ts"
import style0 from "./AddPPMyearly.vue?vue&type=style&index=0&id=40cffb6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cffb6e",
  null
  
)

export default component.exports